<h1>{{listEl.selectedOptions.selected[0]?.value ? 'Edit' : 'New'}} {{title}}</h1>
<button *ngIf="listEl.selectedOptions.selected[0]?.value" mat-mini-fab color="accent" (click)="listEl.deselectAll(); form.reset()">
  <mat-icon>add</mat-icon>
</button>
<div class="crud-container">
  <div>
    <div class="crud-form">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
      <button mat-raised-button color="accent" (click)="save.emit(); form.reset()">Save</button>
    </div>
  </div>
  <div class="crud-list">
    <mat-selection-list #listEl [multiple]="false" (selectionChange)="selectItem($event)">
      <mat-list-option *ngFor="let item of list" [value]="item">
        <div class="list-content">
          <div>
            <ng-container *ngTemplateOutlet="listTemplate; context: {$implicit: item}"></ng-container>
          </div>
          <button mat-icon-button color="warn" (click)="onRemove($event, item)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>
